import React from "react";
import "./DiveagarHarihareshwarPackage.css";

const itinerary = [
  {
    day: "Day 1",
    title: "Pune to Diveagar",
    places: ["Pune", "Diveagar Beach"],
    note: "Diveagar visit & night stay",
  },
  {
    day: "Day 2",
    title: "Diveagar to Shrivardhan & Harihareshwar",
    places: [
      "Diveagar",
      "Shrivardhan Beach",
      "Harihareshwar",
    ],
    note: "Beach sightseeing & local visit",
  },
  {
    day: "Day 3",
    title: "Harihareshwar to Pune",
    places: [
      "Harihareshwar",
      "Local Sightseeing",
      "Pune",
    ],
    note: "Return journey to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹12,199",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹14,999",
    icon: "🚙",
  },
  {
    name: "Kia Carens",
    price: "₹17,699",
    icon: "🚗",
  },
  {
    name: "Innova Crysta",
    price: "₹19,499",
    icon: "🚐",
    popular: true,
  },
];

export default function DiveagarHarihareshwarPackage() {
  return (
    <section className="konkan-package">
      <div className="konkan-container">

        {/* HEADER */}
        <div className="konkan-header">

          <div className="konkan-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="konkan-logo"
            />
          </div>

          <div className="konkan-header-content">

            <span className="konkan-badge">
              3 DAYS • KONKAN TOUR
            </span>

            <h1>
              Pune to Diveagar, Harihareshwar
              <span> & Shrivardhan Package</span>
            </h1>

            <p>
              Enjoy a relaxing 3-day Konkan beach tour from Pune
              covering Diveagar Beach, Shrivardhan Beach and
              Harihareshwar with a comfortable Commercial Cab from
              Garud Cabs.
            </p>

          </div>
        </div>


        {/* ROUTE */}

        <div className="konkan-route">

          <span className="konkan-route-label">
            COMPLETE ROUTE
          </span>

          <div className="konkan-route-text">
            Pune <b>→</b> Diveagar Beach
            <b> → </b> Shrivardhan Beach
            <b> → </b> Harihareshwar
            <b> → </b> Pune
          </div>

        </div>


        {/* MAIN GRID */}

        <div className="konkan-main-grid">

          {/* ITINERARY */}

          <div className="konkan-card">

            <div className="konkan-section-heading">

              <div className="konkan-heading-number">
                03
              </div>

              <div>
                <small>KONKAN TRAVEL PLAN</small>
                <h2>3-Day Beach Tour Itinerary</h2>
              </div>

            </div>


            <div className="konkan-timeline">

              {itinerary.map((item, index) => (

                <div
                  className="konkan-timeline-item"
                  key={item.day}
                >

                  <div className="konkan-day-number">
                    {index + 1}
                  </div>

                  <div className="konkan-day-content">

                    <span className="konkan-day-label">
                      {item.day}
                    </span>

                    <h3>{item.title}</h3>

                    <div className="konkan-places">

                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>

                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}

                        </React.Fragment>
                      ))}

                    </div>

                    <div className="konkan-day-note">
                      🌴 {item.note}
                    </div>

                  </div>

                </div>

              ))}

            </div>

          </div>


          {/* RIGHT SIDE */}

          <div className="konkan-side">

            {/* PACKAGE DETAILS */}

            <div className="konkan-card konkan-details">

              <span className="konkan-mini-label">
                TOUR DETAILS
              </span>

              <h2>Konkan Beach Package</h2>

              <div className="konkan-detail-row">
                <span>Starting Point</span>
                <strong>Pune</strong>
              </div>

              <div className="konkan-detail-row">
                <span>Duration</span>
                <strong>3 Days</strong>
              </div>

              <div className="konkan-detail-row">
                <span>Destination</span>
                <strong>Diveagar</strong>
              </div>

              <div className="konkan-detail-row">
                <span>Beach</span>
                <strong>Shrivardhan</strong>
              </div>

              <div className="konkan-detail-row">
                <span>Destination</span>
                <strong>Harihareshwar</strong>
              </div>

              <div className="konkan-detail-row">
                <span>Trip Type</span>
                <strong>Private Round Trip</strong>
              </div>

            </div>


            {/* HIGHLIGHTS */}

            <div className="konkan-card konkan-highlights">

              <span className="konkan-mini-label">
                TOUR HIGHLIGHTS
              </span>

              <div className="konkan-highlight-grid">

                <div>
                  <span>✓</span>
                  Diveagar Beach
                </div>

                <div>
                  <span>✓</span>
                  Shrivardhan Beach
                </div>

                <div>
                  <span>✓</span>
                  Harihareshwar
                </div>

                <div>
                  <span>✓</span>
                  Konkan Coast
                </div>

                <div>
                  <span>✓</span>
                  Commercial Cab
                </div>

                <div>
                  <span>✓</span>
                  Pune Round Trip
                </div>

              </div>

            </div>


            {/* NOTE */}

            <div className="konkan-note">

              <strong>
                🌊 Explore the Konkan Coast
              </strong>

              <p>
                A comfortable Commercial Cab tour covering the beautiful
                beaches and coastal destinations of Diveagar,
                Shrivardhan and Harihareshwar.
              </p>

            </div>

          </div>

        </div>


        {/* PRICING */}

        <div className="konkan-pricing">

          <div className="konkan-pricing-heading">

            <div>

              <span className="konkan-mini-label">
                CHOOSE YOUR CAB
              </span>

              <h2>3-Day Package Price</h2>

            </div>

            <p>
              Pune → Konkan Tour → Pune
            </p>

          </div>


          <div className="konkan-vehicle-grid">

            {vehicles.map((vehicle) => (

              <div
                className={`konkan-vehicle-card ${
                  vehicle.popular ? "konkan-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="konkan-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="konkan-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="konkan-vehicle-info">

                  <h3>{vehicle.name}</h3>

                  <small>
                    3-Day Konkan Package
                  </small>

                </div>

                <div className="konkan-price">
                  {vehicle.price}
                </div>

              </div>

            ))}

          </div>

        </div>


        {/* BOOKING CTA */}

        <div className="konkan-booking">

          <div>

            <span>
              GARUD CABS • PUNE
            </span>

            <h2>
              Book Your Konkan Beach Tour
            </h2>

            <p>
              Diveagar • Shrivardhan • Harihareshwar • Commercial Cab
            </p>

          </div>

          <a
            href="tel:+919970007784"
            className="konkan-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}